import React from 'react';
import SmartImage from '../../subcomponents/SmartImage';
import Cta from '../../subcomponents/Cta';
import findAltText from '../../utils';

import './engage.scss';

function Engage({
  element,
  url,
  isBootroom,
  loaded,
  campaignType,
  order,
  version
}) {
  const {
    cta,
    arrowDownColor,
    hideArrowDown,
    noBackground,
    backgroundColor,
    useGradient,
    backgroundGradient,
    gradientDirection,
    hideFullRange,
    moveCtaAndArrow,
    engageNumber,
    hide,
    h1Position,
    h1Color,
    h1Hide,
    localEngage,
    moveUpAmount,
    engageHeight,
    type,
    hideAllCta,
    anchorName,
    content,
    roundedCorners,
    removeArrow,
    mobileBackgroundImageFormat,
    desktopBackgroundImageFormat
  } = element;
  const { slug, imagePattern } = url;
  const commonTranslations = window.campaign_data.common_translations.blocks;
  const translations = window.campaign_data.campaign_translations.blocks;
  const uppercaseLetters = url.generalData
    ? url.generalData.uppercaseLetters
    : false;

  // Variables for Campaign H1 adding the classes to an array depending on user input.
  const h1Classes = ['title', h1Position];
  if (h1Hide) h1Classes.push('hide');
  let titleTranslation = translations.campaignh1;
  if (campaignType === 'general') titleTranslation = translations.campaignh1;
  if (campaignType === 'general' && content !== undefined)
    titleTranslation = translations[`${content}h1`];

  const campaignH1 = (
    <h1 style={{ color: h1Color }} className={h1Classes.join(' ')}>
      {titleTranslation}
    </h1>
  );
  // If it's not the first engage component then use h2 instead of h1
  const engageTitle = (
    <h2 style={{ color: h1Color }} className={h1Classes.join(' ')}>
      {titleTranslation}
    </h2>
  );

  // Classes for engage section and smart image
  const sectionClasses = ['component', 'engage-section'];
  const smartImageClasses = [''];
  if (noBackground) sectionClasses.push('smart-section');
  if (uppercaseLetters) sectionClasses.push('title--uppercase');
  switch (engageHeight) {
    case 'small':
      // sectionClasses.push('saleHeightEngage');
      smartImageClasses.push('small-height-engage');
      break;
    case 'medium':
      // sectionClasses.push('medium-height-engage');
      smartImageClasses.push('medium-height-engage');
      break;
    default:
      break;
  }

  let engageName = `010-engage${imagePattern}`;
  if (localEngage)
    engageName = `010-${window.config.language_code}-engage${imagePattern}`;
  if (campaignType === 'general')
    engageName = `010-engage${engageNumber}${imagePattern.split('.')[0]}${
      desktopBackgroundImageFormat !== undefined
        ? desktopBackgroundImageFormat
        : '.jpg'
    }`;

  // If no background image, the engage will load immediately, otherwise pass loaded() to smartImage
  if (noBackground) loaded();
  if (hide) loaded();
  // If url includes a hash (anchor), the engage will load immediately
  if (window.location.hash) loaded();

  const roundTheCorners =
    campaignType === 'general' && roundedCorners ? 'rounded-corners' : '';
  let styler = {};
  if (noBackground && useGradient && gradientDirection === 'leftToRight') {
    styler = {
      background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)`
    };
  } else if (
    noBackground &&
    useGradient &&
    gradientDirection === 'topToBottom'
  ) {
    styler = {
      background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)`
    };
  } else if (noBackground && !useGradient) {
    styler = { background: backgroundColor };
  } else {
    styler = {};
  }
  let component = null;
  if (!hide) {
    component = (
      <section
        id={anchorName || ''}
        className={sectionClasses.join(' ')}
        style={styler}
        // eslint-disable-next-line react/no-unknown-property
        dataorder={order}
        // eslint-disable-next-line react/no-unknown-property
        datatype={type}
      >
        {!noBackground && (
          <SmartImage
            className={
              campaignType === 'general'
                ? 'heightBackground'
                : smartImageClasses.join(' ')
            }
            slug={slug}
            name={engageName}
            mobilename={
              campaignType === 'general'
                ? `010-engage${engageNumber}${imagePattern.split('.')[0]}${
                    mobileBackgroundImageFormat !== undefined
                      ? mobileBackgroundImageFormat
                      : '.jpg'
                  }`
                : undefined
            }
            loaded={loaded}
            version={version}
            campaignType={campaignType}
            alt={findAltText(
              `engage${
                engageNumber !== '1' ? ` ${engageNumber} ` : ' '
              }background`,
              titleTranslation
            )}
          />
        )}
        <div className="mainWidth">
          {!isBootroom && !hideAllCta && campaignType !== 'sale' && (
            <div
              className="holder"
              style={
                campaignType === 'general' && moveCtaAndArrow === true
                  ? { bottom: `${3 + Number(moveUpAmount)}%` }
                  : {}
              }
            >
              <Cta
                className={roundTheCorners}
                url={translations.linkproduct}
                translation={commonTranslations.shopnow}
                backgroundColor={cta.backgroundColor1}
                textColor={cta.textColor1}
                ctaArrowColor={cta.ctaArrowColor1}
                borderColor={cta.ctaBorderColor1}
                noArrow={removeArrow}
                campaignType={campaignType}
              />
              {!hideFullRange && (
                <Cta
                  className={`cta-fullrange ${roundTheCorners}`}
                  url={translations.linkcategory}
                  translation={commonTranslations.seefullrange}
                  backgroundColor={cta.backgroundColor2}
                  textColor={cta.textColor2}
                  ctaArrowColor={cta.ctaArrowColor2}
                  borderColor={cta.ctaBorderColor2}
                  noArrow={removeArrow}
                  campaignType={campaignType}
                />
              )}
            </div>
          )}
          {(campaignType === 'sale' && campaignH1) ||
            (campaignType === 'general' &&
              engageNumber === ('1' || undefined) &&
              campaignH1) ||
            (campaignType === 'general' && engageTitle)}
        </div>
        {((campaignType === 'general' && !hideArrowDown) ||
          campaignType !== 'general') && (
          <div
            className="arrowHolder"
            style={
              campaignType === 'general' && moveCtaAndArrow === true
                ? { bottom: `${2 + Number(moveUpAmount)}%` }
                : {}
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19.94"
              height="10.875"
              viewBox="0 0 21.94 12.875"
            >
              <path
                className="arrowDownSvg"
                stroke={arrowDownColor}
                fill="none"
                d="M4161.98,749.92l-9.98,9.436-9.98-9.436"
                transform="translate(-4141.03 -747.469)"
              />
            </svg>
          </div>
        )}
      </section>
    );
  }

  return component;
}

export default Engage;
